import { formatINR, formatIndianNumber } from "@/lib/format";

export const KpiCard = ({ kpi }) => {
  const displayValue = kpi.is_currency
    ? formatINR(kpi.value)
    : typeof kpi.value === "number"
    ? formatIndianNumber(kpi.value)
    : kpi.value;
  const isUp = kpi.delta?.startsWith("+");
  return (
    <div
      className="bg-white border border-[#DCE3DF] rounded-[10px] shadow-[0_4px_20px_rgba(20,30,26,0.06)] p-5"
      data-testid={`kpi-card-${kpi.label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <p className="text-xs font-mono uppercase tracking-[0.08em] text-[#5A6B63]">{kpi.label}</p>
      <p className="text-2xl font-mono font-medium text-[#141E1A] mt-2">{displayValue}</p>
      {kpi.delta && (
        <p className={`text-xs font-mono mt-1 ${isUp ? "text-[#B7791A]" : "text-[#0E6E52]"}`}>{kpi.delta}</p>
      )}
    </div>
  );
};
